import type { BranchCategory } from '@festina/configuration-general-types/configuration'
import { BranchCategories } from '@festina-life/api'
import type { ExcludeString, Optional } from '@festina-life/core'

export function loadTypedDataFromFile<T extends { _type: string }>(
  file: File,
  assertOnTypeName: ExcludeString<T['_type']>[],
): Promise<T>
export function loadTypedDataFromFile<T extends { _type: string }>(
  file: File,
  assertOnTypeName: ExcludeString<T['_type']>,
): Promise<T>
export function loadTypedDataFromFile<T extends { _type: string }>(
  file: File,
  assertOnTypeName: ExcludeString<T['_type']> | ExcludeString<T['_type']>[],
) {
  return new Promise<T>((resolve, reject) => {
    const fileReader = new FileReader()
    const assertOnTypeNames = Array.isArray(assertOnTypeName)
      ? assertOnTypeName
      : [assertOnTypeName]

    fileReader.onload = (event) => {
      if (event.target?.result) {
        try {
          const parsedJson = JSON.parse(event.target.result as string)

          if (
            assertOnTypeNames.some(
              (supportedTypeName) => parsedJson._type === supportedTypeName,
            )
          ) {
            resolve(parsedJson as T)
          } else {
            reject(
              new Error(
                `The file is not of type ${assertOnTypeNames.join(', ')}. Found ${parsedJson._type} instead.`,
              ),
            )
          }
        } catch {
          reject(
            new Error(
              `Could not parse the file of type ${assertOnTypeNames.join(', ')}`,
            ),
          )
        }
      } else {
        reject(
          new Error(
            `Could not load the file of type ${assertOnTypeNames.join(', ')}`,
          ),
        )
      }
    }

    fileReader.onerror = reject
    fileReader.readAsText(file)
  })
}

export const allowedBranchesForBaseBranchCategory: Record<
  BranchCategory,
  BranchCategory[]
> = {
  main: ['feature', 'release'],
  feature: ['feature'],
  release: ['feature', 'release'],
  none: ['none'],
}

export const getAllowedBranchCategoriesForBaseBranchCategory = (
  baseBranchCategory: Optional<BranchCategory>,
) =>
  baseBranchCategory && BranchCategories.includes(baseBranchCategory)
    ? allowedBranchesForBaseBranchCategory[baseBranchCategory]
    : [...BranchCategories.filter((category) => category !== 'none')]
